import getDeviceInfo from '@/lib/base/getDeviceInfo';
import {removeLocalData, saveLocalData} from '@/lib/base/localData';
import Message from '@/lib/base/message';
import store from '@/store/index.js';
import i18n from '@/i18n/index.js';
import userService from '@/services/user';
import regionCodes from '@/config/regionCodes';
import url from '@/lib/api/url';

const state = {
  cdn: url.cdn,
  viewMode: '',
  device: '',
  orientation: '',
  width: 0,
  height: 0,
  platform: 'web',
  isLoading: false,
  isReviewGameLoading: false,
  isSwitchCourseSheetShow: false,
  isSidebarShow: false,
  isModalPostQuestionShow: false,
  isSidebarTeacherShow: false,
  isShowVipModal: false,
  hasVerificationNotification: false,
  isCheatMode: false,
  locale: 'zh-CN',
  localeAlias: '简中',
  localeName: '简体中文',
  isChangeLocaleModalShow: false,
  localeList: [
    {
      code: 'zh-CN',
      name: '简体中文',
    },
    {
      code: 'en-US',
      name: 'English',
    },
  ],
  localePriceList: [
    {
      code: 'zh-CN',
      currency: 'USD',
    },
    {
      code: 'en-US',
      currency: 'USD',
    },
  ],
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  isReviewGameLoading(state) {
    return state.isReviewGameLoading;
  },
  isShowVipModal(state) {
    return state.isShowVipModal;
  },
  viewMode(state) {
    return state.viewMode;
  },
  device(state) {
    return state.device;
  },
  permission() {
    return store.getters['course/currentPlan']?.contents || {};
  },
  regionCodes() {
    const local = state.locale;
    return regionCodes.sort((a, b) => {
      return (a.sort[local] || 9999) - (b.sort[local] || 9999);
    });
  },
  isIos(state) {
    return state.platform === 'ios';
  },
  isAndroid(state) {
    return state.platform === 'android';
  },
  isChinese(state) {
    return state.locale.includes('zh');
  },
};

const actions = {
  openModalPostQuestion({commit}) {
    commit('openModalPostQuestion');
  },
  closeModalPostQuestion({commit}) {
    commit('closeModalPostQuestion');
  },
  openChangeLocaleModal({commit}) {
    commit('openChangeLocaleModal');
  },
  closeChangeLocaleModal({commit}) {
    commit('closeChangeLocaleModal');
  },
  async changeLocale({commit}, locale) {
    if (store.getters['user/isLogin']) {
      await userService.updateUser({language: locale});
    }

    removeLocalData('videoTextTrack'); // 影片字幕語言
    removeLocalData('videoAudioTrack'); // 影片語音語言
    commit('changeLocale', locale);
  },
  async initLocale({commit}, locale) {
    if (store.getters['user/isLogin']) {
      await userService.updateUser({language: locale});
    }
    commit('changeLocale', locale);
  },
  init({commit}) {
    const data = getDeviceInfo();
    commit('setEnv', data);
  },
  changePlanInit({rootGetters}, plan) {
    const currentPlan = rootGetters['course/currentPlan'];
    if (currentPlan.id === plan.id) {
      return;
    }

    saveLocalData('plan-info', JSON.stringify(plan));
    store.commit('course/setCurrentPlan', plan);
    store.dispatch('tsumeGame/getPracticeTsumeList', plan.id);
    store.dispatch('course/getCourses', plan.id);
    Message.success(i18n.t('已切换课程'), 3000);
  },
};

const mutations = {
  openModalPostQuestion(state) {
    state.isModalPostQuestionShow = true;
  },
  closeModalPostQuestion(state) {
    state.isModalPostQuestionShow = false;
  },
  openChangeLocaleModal(state) {
    state.isChangeLocaleModalShow = true;
  },
  closeChangeLocaleModal(state) {
    state.isChangeLocaleModalShow = false;
  },
  changeLocale(state, locale) {
    state.locale = locale;
    state.localeName = state.localeList.find(
      (item) => item.code === locale
    ).name;
    saveLocalData('locale', locale);
  },
  setEnv(state, data) {
    const {viewMode, device, orientation, height, width} = data;
    state.viewMode = viewMode;
    state.device = device;
    state.orientation = orientation;
    state.width = width;
    state.height = height;
  },
  setIsLoading(state, value) {
    state.isLoading = value;
  },
  setIsReviewGameLoading(state, value) {
    state.isReviewGameLoading = value;
  },
  setIsSwitchCourseSheetShow(state, value) {
    state.isSwitchCourseSheetShow = value;
  },
  setIsSidebarShow(state, value) {
    state.isSidebarShow = value;
    if (value) {
      state.isSidebarTeacherShow = false;
    }
  },
  setIsSidebarTeacherShow(state, value) {
    state.isSidebarTeacherShow = value;
    if (value) {
      state.isSidebarShow = false;
    }
  },
  setHasVerificationNotification(state, value) {
    state.hasVerificationNotification = value;
  },
  toggleCheatMode(state) {
    state.isCheatMode = !state.isCheatMode;
  },
  setIsShowVipModal(state, value) {
    state.isShowVipModal = value;
  },
  setPlatform(state, value) {
    state.platform = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
